/* =========================================================================
   Home FAB — a persistent one-tap "return home" button pinned bottom-left,
   the fixed counterpart of the in-flow "← Home" pills, which scroll away
   with the content (the monastery runs several screens deep now).

   Section screens only: hidden on home itself (nothing to return to), on
   the pre-auth screens (welcome/login/register own their own flow), and on
   the mid-game pause screens, where a stray tap would abandon the run —
   the account menu's labeled "End game & go Home" stays the deliberate
   exit there. Navigation reuses accountMenu's goHome() so the two ways
   home can never drift apart.
   ========================================================================= */
import { goHome } from './accountMenu';
import { icon } from './ui/icons';

export const homeFabHTML = /* html */ `
<div id="homeFab" class="hfab hidden">
  <button id="hfabBtn" class="hfab-btn" type="button" aria-label="Back to Home">
    <span class="hfab-ic" aria-hidden="true">${icon('home', 20)}</span>
  </button>
</div>`;

/** Screens where a one-tap Home is safe and useful. Deliberately excludes
    'home', the pre-auth trio, and the PAUSE_SCREENS ('roundintro',
    'nextround') — see the header comment. */
const FAB_SCREENS = new Set([
  'results',
  'history',
  'feast',
  'collections',
  'pilgrimage',
  'monastery',
  'leaderboard',
  'friendly',
]);

/** Pure visibility rule (unit-tested). */
export function homeFabVisible(screen: string): boolean {
  return FAB_SCREENS.has(screen);
}

/** Wire the click once at boot (after the shell HTML is in the DOM). */
export function initHomeFab(): void {
  document.getElementById('hfabBtn')?.addEventListener('click', goHome);
}

/** Show/hide per screen; called from main's single onScreenShown hook. */
export function syncHomeFab(screen: string): void {
  document.getElementById('homeFab')?.classList.toggle('hidden', !homeFabVisible(screen));
}
